export default __webpack_public_path__ + "static/media/classes.d05e3053.svg";